var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileFilterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3038_3959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.42698 9.87184C8.77392 10.3266 8.6702 9.94759 8.6702 19.0123C8.6702 19.8235 9.69195 20.2878 10.412 19.8025C13.4892 17.7011 14.1039 17.5191 14.1039 16.5362C14.1039 9.93059 14.0189 10.302 14.3472 9.87184L19.344 3.71094H3.43018L8.42698 9.87184Z",
    fill: "#2169C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2318 0.502343C21.0533 0.192578 20.7031 0 20.3176 0H2.45718C1.62465 0 1.13479 0.850667 1.61236 1.46875C1.61628 1.47468 1.55815 1.40262 2.48003 2.53907H20.2947C21.0804 1.57058 21.6055 1.15215 21.2318 0.502343Z",
    fill: "#2169C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3038_3959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileFilterIcon);
export default __webpack_public_path__ + "static/media/profile_filter_icon.ffc2062ef15ed647ee05c24d8dcea841.svg";
export { ForwardRef as ReactComponent };